import { Component, OnInit, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { MatDialogRef } from '@angular/material';

import { DServicio, DRespuestaSimple, DContextoMuisca } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DParametrosPolitica, DParametroPolitica, DValorDominio, DLugar } from '@dian/api-basicos-parametricas';
import { DReciboPago490Servicios, DLiquidacionRecibo, DRtaLiquidacionReciboPago, DConceptoLiquidacionRecibo, DListEntidadesBancarias, DEntidadBancaria, DDeudorSolidarioSubsidiario } from '@dian-api/recibo-pago490';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/recibo-pago/src/servicios/doperaciones-matematicas.servicio';

@Component({
  selector: 'app-pago',
  templateUrl: './pago.component.html',
  styleUrls: ['./pago.component.css'],
  providers: [
    DReciboPago490Servicios,
    DBasicosParametricasServicios,
    DServicio,
    DatePipe
  ]  
})
export class PagoComponent implements OnInit {

  public step: number = 2;
  public seleccion: string;
  public modelo: DLiquidacionRecibo;
  public mensajeAntesGuardar: string;
  public modeloConcepto: DConceptoLiquidacionRecibo;
  public fechaMinima: Date = new Date();
  public listCodigosTitulos: Array<DValorDominio>;
  public listDptos: Array<DLugar>;
  public listMpios: Array<DLugar>;
  public listEntidadesBancariasPSE: DListEntidadesBancarias;
  public listEntidadesBancariasCreditoEnLinea: DListEntidadesBancarias;
  public guardado: boolean = false;
  public reciboPago: DRtaLiquidacionReciboPago;
  public banco: DEntidadBancaria;
  public modeloDeudorSolidario: DDeudorSolidarioSubsidiario;
  public fechaPago: string;
  public innerHeight: number = window.innerHeight;
  //public browserName: string;
  public minFecha: Date = new Date();
  public stateInput: {error: boolean, message: string, dateString: string};
  public contextoUsuario: DContextoMuisca;
  public tieneFirmaElectronica: boolean;
  public disableCreditoLinea: boolean = true;
  public usaPagoPSE: boolean;
  public listCuotas: Array<number> = new Array<number>();


  private politica401: DParametrosPolitica;
  private numRepeticion: string;
  public sancion: string;
  public interes: string;
  public impuesto: string;
  public totalPagar: string;
  public sancionUSD: string;
  public interesUSD: string;
  public impuestoUSD: string;
  public totalPagarUSD: string;

  constructor(   
    private dialogRef: MatDialogRef<PagoComponent>,
    private _servicioREST: DReciboPago490Servicios,
    private _servcioParametricasREST: DBasicosParametricasServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private datePipe: DatePipe,
    private dutilidades: DOperacionesMatematicasServicio
  ) {
    this.contextoUsuario = new DContextoMuisca();
    this.modelo = new DLiquidacionRecibo();    
    this.modeloConcepto = new DConceptoLiquidacionRecibo();
    this.listCodigosTitulos = new Array<DValorDominio>();
    this.listDptos = new Array<DLugar>();
    this.listMpios = new Array<DLugar>();
    this.banco = new DEntidadBancaria();
    this.modeloDeudorSolidario = new DDeudorSolidarioSubsidiario();
    this.listEntidadesBancariasPSE = new DListEntidadesBancarias();
    this.listEntidadesBancariasCreditoEnLinea = new DListEntidadesBancarias();
    this.reciboPago = new DRtaLiquidacionReciboPago();
    this.fechaPago = this.datePipe.transform(new Date(), 'yyyy/MM/dd', 'UTC-5');
    this.politica401 = new DParametrosPolitica();
  }

  ngOnInit() {
    if (this.modelo.conceptos && this.modelo.conceptos.length === 1) this.modeloConcepto = this.modelo.conceptos[0];    
    setTimeout(() => {
      this.obtenerDatosParametricas();      
      this.obtenerBancosPagoEnLinea();
      this.construirListaCuotas();
      this.obtenerPolitica();    
    }, 50);
  }

  public cambioFocoCasillas(e, el, remover?:boolean) {               
    if (!remover) 
      if (e.keyCode == 13) el.focus();
    else el.blur();
  }

  private construirListaCuotas() {
    if (Number(this.modelo.totalCuotas) > 1) {
      this.modelo.numCuota = null;
      for (let i = 1; i <= Number(this.modelo.totalCuotas); i++) {
        this.listCuotas.push(i);
      }
    }
  }

  private obtenerDatosParametricas() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servcioParametricasREST.obtenerValoresDominio('139')
      .subscribe(
        res => {
          this.listCodigosTitulos = <Array<DValorDominio>>res;
          preloader.close();
        },
        error => {
          this.dNotificacionServicio.mostrarDialogoError('Error obteniendo datos de parametricas', error.descripcion);
          preloader.close();
        }
      );
  }


  private obtenerBancosPagoEnLinea() {  
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();    
    this._servicioREST.obtenerBancosPagoEnLineaPSE()
      .subscribe(
        res => {
          this.listEntidadesBancariasPSE = <DListEntidadesBancarias>res;         
          preloader.close();
        },
        error => {          
          this.dNotificacionServicio.mostrarDialogoError('Error consultando los bancos para pago por PSE ', error.descripcion);
          preloader.close();
        }
      );
  }

  private obtenerBancosCreditoEnLinea() {
    if (!this.modeloConcepto['id']) {
      this.dNotificacionServicio.mostrarDialogoInformacion("Seleccione el concepto");
      this.guardado = false;
      return;
    }

    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servicioREST.obtenerBancosCreditoEnLinea(String(this.reciboPago.ideDocumento), this.modeloConcepto.id, this.modelo.fechaPago)
      .subscribe(
        res => {    
          const listEntidadesBancarias = <DListEntidadesBancarias>res;
          listEntidadesBancarias.listEntidadesBancarias.forEach((item, index) => {
            if (!this.validarBancoCreditoEnLinea(item.codEntidadRecaudadora))
              listEntidadesBancarias.listEntidadesBancarias.splice(index, 1);
          });

          this.disableCreditoLinea = !listEntidadesBancarias.listEntidadesBancarias.length;
          this.listEntidadesBancariasCreditoEnLinea = listEntidadesBancarias;
          precarga.close();
        },
        error => {
          this.dNotificacionServicio.mostrarDialogoError('Error consultando los bancos para credito en línea ', error.descripcion);
          precarga.close();
        }
      );
  }

  private validarBancoCreditoEnLinea(id: number): boolean {
    const parametros = this.obtenerParametro('BANCOS_PAGO_CREDITO_LINEA');
    const tipoUsuario = this.contextoUsuario.NitOrganizacion ? 'J' : 'N';
    const valores = parametros.valor.split(',');    
    let bandera = false;

    if (!valores.length) return false;
    for (let i in valores) {
      const valor = valores[i].split('-');
      if (Number(valor[0]) === id) {
        if (valor[1] === tipoUsuario || valor[1] === 'A')
          bandera = true;
      }
    }
    return bandera;
  }

  public calcularInteresRecibo() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga('Calculando Intereses');  
    let modeloBorrador: DLiquidacionRecibo = this.obtenerModeloBorrador();
    
    this._servicioREST.calcularInteresRecibo(modeloBorrador)
      .subscribe(
        res => {
          let modeloRespuesta: DLiquidacionRecibo = <DLiquidacionRecibo>res;          
          this.modelo.totalValorMonetario.interes = modeloRespuesta.totalValorMonetario.interes;
          //this.dNotificacionServicio.mostrarDialogoInformacion("Interes del recibo calculado.");
          this.calcularTotal();
          preloader.close();
        },
        error => {          
          this.dNotificacionServicio.mostrarDialogoError("Error calculando el interes del recibo de pago", error.descripcion);
          preloader.close();
        }
      );
  }

  public generarReciboPago() {
    if (!this.modeloConcepto['id'] || !this.modelo.numCuota || this.stateInput && this.stateInput.error) {
      this.dNotificacionServicio.mostrarDialogoError('Error llene los campos correctamente');
    } else {
      if (this.mensajeAntesGuardar) {
        this.dNotificacionServicio.mostrarDialogoConfirmacion(this.mensajeAntesGuardar)
          .afterClosed()
          .subscribe(
            res => {
              if (!res) return;
              this.ejecutarGenerarReciboPago();
            }
          );
      } else this.ejecutarGenerarReciboPago();
    }    
  }

  private ejecutarGenerarReciboPago() {
    if (this.totalPagar == "0") {
      this.dNotificacionServicio.mostrarDialogoInformacion("Para generar el recibo este debe tener un valor a pagar");
      return;
    }

    let preloader = this.dNotificacionServicio.mostrarDialogoCarga('Generando Recibo');  
    let modeloBorrador: DLiquidacionRecibo = this.obtenerModeloBorrador();
    
    this._servicioREST.generarReciboPago(modeloBorrador)
      .subscribe(
        res => {
          this.reciboPago = <DRtaLiquidacionReciboPago>res;
          this.guardado = true;
          //this.dNotificacionServicio.mostrarDialogoInformacion('Recibo de pago generado');
          
          //Obtiene la lista de bancos para credito en linea una vez se ha guardado el documento
          const parametros = this.obtenerParametro('BANCOS_PAGO_CREDITO_LINEA');
          if (parametros.valor) this.obtenerBancosCreditoEnLinea(); 
          preloader.close();
        },
        error => {          
          this.dNotificacionServicio.mostrarDialogoError('Error generando recibo de pago', error.descripcion);
          preloader.close();
        }
      );
  }

  private obtenerModeloBorrador() {
    this.modelo.fechaPago = this.fechaPago.replace(/\//g,'-'); 
    if (!this.modelo.codigoTitulo) delete this.modelo.codigoTitulo;
    let modeloBorrador: DLiquidacionRecibo = this.modelo;
    modeloBorrador.concepto = this.modeloConcepto;
    let sancion = this.dutilidades.redondearValorMoneda(this.sancion, false);
    let interes = this.dutilidades.redondearValorMoneda(this.interes, false);
    let impuesto = this.dutilidades.redondearValorMoneda(this.impuesto, false);
    let totalPagar = this.dutilidades.redondearValorMoneda(this.totalPagar, false);
    let sancionUSD = this.dutilidades.redondearValorMoneda(this.sancionUSD, false);
    let interesUSD = this.dutilidades.redondearValorMoneda(this.interesUSD, false);
    let impuestoUSD = this.dutilidades.redondearValorMoneda(this.impuestoUSD, false);
    let totalPagarUSD = this.dutilidades.redondearValorMoneda(this.totalPagarUSD, false);
    modeloBorrador.totalValorMonetario.sancion = this.dutilidades.deshacerFormatoMoneda(sancion);  
    modeloBorrador.totalValorMonetario.interes = this.dutilidades.deshacerFormatoMoneda(interes);  
    modeloBorrador.totalValorMonetario.impuesto = this.dutilidades.deshacerFormatoMoneda(impuesto); 
    modeloBorrador.totalValorMonetario.totalPagar = this.dutilidades.deshacerFormatoMoneda(totalPagar);  
    modeloBorrador.totalValorMonetario.sancionUSD = this.dutilidades.deshacerFormatoMoneda(sancionUSD);  
    modeloBorrador.totalValorMonetario.interesUSD = this.dutilidades.deshacerFormatoMoneda(interesUSD);  
    modeloBorrador.totalValorMonetario.impuestoUSD = this.dutilidades.deshacerFormatoMoneda(impuestoUSD); 
    modeloBorrador.totalValorMonetario.totalPagarUSD = this.dutilidades.deshacerFormatoMoneda(totalPagarUSD);  
    if (this.modeloDeudorSolidario.identificacion) modeloBorrador.deudor = this.modeloDeudorSolidario;
    return modeloBorrador;
  }

  public generarPDF() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._servicioREST.descargarPDFReciboPago(String(this.reciboPago.ideDocumento))
      .subscribe(
        res => {     
          let descarga: DRespuestaSimple = new DRespuestaSimple(); 
          descarga = res;              
          let mediaType = 'application/pdf';
          let blob = new Blob([descarga.blob], {type: mediaType});
          let filename = this.reciboPago.ideDocumento + '.pdf';                            
          saveAs(blob, filename);      
          preloader.close();
        },
        error => {
          this.dNotificacionServicio.mostrarDialogoError('Error generando PDF', error.descripcion);
          preloader.close();
        }
      );
  }

  public redireccionarPago(tipo: string) { 
    if (!this.tieneFirmaElectronica) this.validarPolitica(tipo);
    else this.validarRedireccion(tipo);
  }

  private validarPolitica(tipo?: string) {
    const parametros = this.obtenerParametro('FORMATOS_EXCLUIDOS');
    let bandera = parametros && parametros.valor && (parametros.valor.indexOf(String(this.modelo.formato)) > -1);
    if (!bandera)
      this.dNotificacionServicio.mostrarDialogoInformacion('Para realizar pago electrónico la declaración debe estar presentada.');
    else this.validarRedireccion(tipo);    
  }

  private obtenerPolitica() {
    let preloader = this.dNotificacionServicio.mostrarDialogoCarga();    
    this._servcioParametricasREST.obtenerPolitica(401)
      .subscribe(
        res => {          
          this.politica401 = <DParametrosPolitica>res;
          preloader.close();
        },
        error => {
          preloader.close();
          console.error("Error consultado la politica ", error);
          //this.dNotificacionServicio.mostrarDialogoError('Error obteniendo la politica ', error.descripcion);
        }
      );
  }

  private obtenerParametro(parametro: string): DParametroPolitica {
    for (let item of this.politica401.parametros) {
      if (item.nombre === parametro) return item;
    }
    return null;
  }

  // private validarRedireccion(tipo: string) {
  //   if (this.reciboPago.numRepeticion) {
  //     this.seleccion = tipo;
  //     if (tipo === 'PSE') {
  //       if (this.usaPagoPSE) this.step = 2;
  //       else 
  //         window.open("/WebEntradasalida/DefInicioTransaccionPago.faces?numDocumento=" + this.reciboPago.ideDocumento  + "&numRepeticion=" + this.reciboPago.numRepeticion + "","","width=700,height=400,scrollbars=yes,resizable=yes");           
  //     }
  //     if (tipo === 'credito') this.step = 2;      
  //   }
  // }

  private validarRedireccion(tipo: string) {
    if (this.reciboPago.numRepeticion) {
      this.seleccion = tipo;
      // this.denvioData.enviarCambiarFlujo('datosPago');
      if (tipo === 'PSE') {
        if (this.usaPagoPSE) this.step = 2;
        else
          window.open("/WebEntradasalida/DefInicioTransaccionPago.faces?numDocumento=" + this.reciboPago.ideDocumento  + "&numRepeticion=" + this.reciboPago.numRepeticion + "","","width=700,height=400,scrollbars=yes,resizable=yes");          
      }
      if (tipo === 'credito') this.step = 2;      
    }
  }
 

  
  /*public redireccionarCreditoEnLinea() {
    if (!this.modeloConcepto.id) this.dNotificacionServicio.mostrarDialogoError('Debe seleccionar un concepto');
    window.open("/WebCreditoEnLinea/credito-en-linea?numDocumento=" + this.reciboPago.ideDocumento + "&tipoImpuesto=" + this.modeloConcepto.id + "&fechaPago=" + this.modelo.fechaPago);
  }*/
  
  // public redireccionarBanco() {
  //   if (!this.banco || !this.banco.urlEntidad) {
  //     this.dNotificacionServicio.mostrarDialogoInformacion("Por favor seleccione el banco");
  //     return;
  //   } 

  //   let notificacion = this.dNotificacionServicio.mostrarDialogoConfirmacion('A continuación ud va a salir de la DIAN y será redirigido a la pagina externa del banco, esta de acuerdo?');
  //   notificacion.afterClosed().subscribe(
  //     res => {
  //       if (!res) return;
  //       window.open(this.banco.urlEntidad, '_blank');
  //     }
  //   );  
    
  // }




  public redireccionarBanco(tipoPago?:string) {
    if (tipoPago) {
      this.seleccion=tipoPago
    }
    
    if (!this.banco || !this.banco.urlEntidad) {
      this.dNotificacionServicio.mostrarDialogoInformacion("Por favor seleccione el banco");
      return;
    }
 
    if (this.seleccion === 'PSE') {
      // let notificacion = this.dNotificacionServicio.mostrarDialogoConfirmacion('Para realizar el pago, será dirigido a la página del banco. ¿Desea continuar?');
      // notificacion.afterClosed().subscribe(
      //   res => {
      //     if (!res) return;
      //     let params = (this.banco.urlEntidad.indexOf('?') > 0) ? '&' : '?';
      //     params = `${params}numReciboPago=${this.reciboPago.ideDocumento}&urlDian=${this.getEnvironment()}/WebEntradasalida/DefRespuestaTransaccionPago.faces`
      //     window.open(this.banco.urlEntidad + params, '_blank');
      //   }
      // );  
        let params = (this.banco.urlEntidad.indexOf('?') > 0) ? '&' : '?';
        params = `${params}numReciboPago=${this.reciboPago.ideDocumento}&urlDian=${this.getEnvironment()}/WebEntradasalida/DefRespuestaTransaccionPago.faces`
        window.open(this.banco.urlEntidad + params, '_blank');
    }
 
    if (this.seleccion === 'credito') {
      let mensaje = "Desde el momento en que  usted haga clic en el bot&oacute;n 'Ir' ya no estar&aacute; en la DIAN. Las transacciones que realice a continuaci&oacute;n se llevan a cabo entre la Entidad Recaudadora y el cliente; a partir de este momento la DIAN no tiene el control de las mismas, ante cualquier inconveniente comun&iacute;quese con su banco.";    
      let botonIr = { text: 'Ir', value: true, color: 'white', backgroundColor: '#069169', disabled: false };
      let buttonCancelar = { text: 'Cancelar', value: false, color: '#069169', backgroundColor: 'white', disabled: false };
      this.dNotificacionServicio.mostrarDialogoPersonalizado('Mensaje', mensaje, null, [botonIr, buttonCancelar], '#069169', 'white', false)
        .afterClosed().subscribe(
          res => {
            //if (res) window.location.href = url;
            if (!res) return;
            window.open(this.banco.urlEntidad, '_blank');
          }
        );
    }    
  }
 




  /**
   * Function to close dialog
   * @param {Any} option selected
   */
  private closeDialog(option?:any) {
    this.dialogRef.close(option);
  }  

  public calcularTotal() {
    let campos = ['sancion', 'interes', 'impuesto'];
    let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, campos, true);
    let resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
    let valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);  
    this.totalPagar = String(valorRedondeado);    
  }

  public operarCamposCuerpo(operacion: DTipoOperacionAritmetica, campos: Array<string>, formatear: boolean): string {                    
    let valores = [];
    for (let i in campos) {
      if (this.dutilidades.validarValorNumerico(this.modelo.totalValorMonetario[campos[i]])) {
        let valor = this.dutilidades.redondearValorMoneda(this.modelo.totalValorMonetario[campos[i]]);            
        valores.push(valor);
      } else {
        valores.push('0');
      }
    }
    return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
  }

  public getDate(dateString: string): Date {
    let splitDate = dateString.split('/');
    let date = new Date(Number(splitDate[0]), Number(splitDate[1]), Number(splitDate[2]));
    return date;
  }

  public getEventInputDateMask(event: {error: boolean, message: string, dateString: string}) {
    this.stateInput = event;
  }
  

  public getEnvironment(): string {
    return window.location.origin;
    /*if (window.location.origin.indexOf('dian') > -1)
      return 'https://muisca.dian.gov.co';
    else
      return 'https://pruebasfuncionales.dian.gov.co';*/
  }
 
}



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/pago/pago.component.ts